import React, { useEffect, useState } from 'react';
import Modal from 'components/Modal';
import { actionsType } from 'config/constants';
import PubSub from 'services/PubSub/';
import ContentBankAccount from './ContentBankAccount';
import style from './style.scss';

let actions = []; 
const ModalAddBankAccount = () => {
    const [userInfo, setUserInfo] = useState({});

    useEffect(()=> {
        actions.push(PubSub.register(actionsType.MODAL.ADD_BANK_ACCOUNT_OPEN, _data));

        return function cleanup () {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    },[])

    const _data = (payload) => {
        setUserInfo(payload.value.userData);
    }

    const closeRescheduleMessage = () => {
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.ADD_BANK_ACCOUNT_CLOSE),0);
    }

    return (
        <Modal customClass="modal-add-bank-account" actionOpen={actionsType.MODAL.ADD_BANK_ACCOUNT_OPEN} actionClose={actionsType.MODAL.ADD_BANK_ACCOUNT_CLOSE}>
            <ContentBankAccount userInfo={userInfo} closeRescheduleMessage={closeRescheduleMessage}/>
        </Modal>
    )
}

export default ModalAddBankAccount;